import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function OrderDetails() {
  const location = useLocation();

  const initialState = location.state;

  const isDesigner = initialState?.fromDesigner || false;

  const [order, setOrder] = useState(initialState);
  // const { state: initialState } = useLocation();
  const navigate = useNavigate();
  // const [order, setOrder] = useState(initialState);
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(5);
  const [downloaded, setDownloaded] = useState({});
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState("");
  const [concepts, setConcepts] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  // --- ZOOM STATES ---
  const [zoomData, setZoomData] = useState({
    show: false,
    x: 0,
    y: 0,
    img: "",
  });
  const BASE_URL = UPLOADS.DESIGN_EMB;
  useEffect(() => {
    fetchConcepts();
  }, []);

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log("Concepts fetch error:", error);
    }
  };
  const getConceptNames = (conceptIds) => {
    if (!conceptIds || !Array.isArray(conceptIds)) return "";

    return (
      conceptIds
        .map((id) => {
          const concept = concepts.find((c) => c.id == id);
          return concept ? concept.concept_name : null;
        })
        .filter(Boolean)
        .join(", ") || ""
    );
  };
  const fetchOrderUpdates = useCallback(() => {
    if (!order?.id) return;

    const url = isDesigner
      ? `${API.GET_DESIGNER_ORDERS}&user_id=${order.designer_id || order.user_id}`
      : `${API.LIST_USER_ORDERS}&user_id=${order.user_id}`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const allOrders = isDesigner
          ? data.orders || []
          : Array.isArray(data)
            ? data
            : data.orders || [];

        const updatedOrder = allOrders.find(
          (o) => Number(o.id) === Number(order.id),
        );

        if (updatedOrder) {
          setOrder({
            ...updatedOrder,
            fromDesigner: isDesigner,
          });
        }
      });
  }, [order?.id, order?.user_id, isDesigner]);
  useEffect(() => {
    if (order && order.status?.toLowerCase() !== "confirmed") {
      const intervalId = setInterval(() => fetchOrderUpdates(), 10000);
      return () => clearInterval(intervalId);
    }
  }, [order?.status, fetchOrderUpdates]);

  const handleDownloadClick = (e, file, designCode, index) => {
    e.preventDefault();

    const url = file;

    setPendingDownloadUrl({
      url,
      code: designCode,
      index,
    });

    setAdTimer(5);
    setShowAdModal(true);
  };

  useEffect(() => {
    let interval;
    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);

  if (!order)
    return <div className="text-center mt-5">No order data found.</div>;

  const isConfirmed = order.status?.toLowerCase() === "confirmed";
  const handleMouseMove = (e, imgUrl) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();

    // Calculate cursor position relative to the image container
    const xPos = e.clientX - left;
    const yPos = e.clientY - top;

    // Calculate percentage for background position
    const xPercent = (xPos / width) * 100;
    const yPercent = (yPos / height) * 100;

    setZoomData({
      show: true,
      x: xPos,
      y: yPos,
      xP: xPercent,
      yP: yPercent,
      img: imgUrl,
    });
  };

  return (
    <div className="order-details-container px-3 py-5 bg-white">
      <div className="container">
        {/* HEADER SECTION (Same as yours) */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">Order {order.order_no}</h2>
          <button
            className="btn btn-light border btn-sm"
            onClick={() =>
              navigate(isDesigner ? "/user/dashboard" : "/myorders")
            }
          >
            <i className="bi bi-arrow-left"></i>Back
          </button>
        </div>

        <div className="row">
          <div className="col-lg-4 mb-4">
            {/* PAYMENT SUMMARY (Same as yours) */}
            {/* <div className="payment-summary-card p-4 border rounded shadow-sm">
                 <h5 className="fw-bold mb-4">Payment Summary</h5>
                 <div className="d-flex justify-content-between">
                    <span>Total Amount:</span>
                    <span className="fw-bold" style={{ color: "#00a99d" }}>Rs. {order.total_amount}</span>
                 </div>
            </div> */}
          </div>

          <h5 className="fw-bold mb-4">Ordered Designs</h5>

          <div className="embOrderTableWrapper">
            <table className="embOrderTable">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Design Preview</th>
                  <th>Details</th>
                  {/* <th>Area</th>
                  <th>Stitch</th>
                  <th>Colors</th> */}
                  <th>Price</th>

                  {isDesigner && (
                    <>
                      <th>Commission</th>
                      <th>Net Earnings</th>
                    </>
                  )}

                  <th>Download</th>
                </tr>
              </thead>

              <tbody>
                {order.items?.map((item, i) => (
                  <tr key={i} className="text-center">
                    <td>{i + 1}</td>

                    <td>
                      <div className="embPreviewBox">
                        {/* <img
                          src={`${API.BASE_URL}/uploads/Design_seller/${item.user_id}/jpg/${item.jpeg_file}`}
                          className="embPreviewImage"
                          alt=""
                        /> */}
                        <img
                          src={`${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.jpeg_file}`}
                          className="embPreviewImage"
                          alt=""
                          style={{ cursor: "zoom-in" }}
                          onClick={() =>
                            setPreviewImage(
                              `${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.jpeg_file}`,
                            )
                          }
                        />
                      </div>
                    </td>

                    <td className="text-start">
                      <div className="fw-bold text-dark mb-1">
                        {item.design_code}
                      </div>

                      <div
                        className="d-flex flex-wrap gap-1"
                        style={{ flexDirection: "column" }}
                      >
                        <span className="tag">
                          <strong>Category:</strong>{" "}
                          {item.category || "General"}
                        </span>

                        <span className="tag">
                          <strong>Stitches: </strong>
                          {item.stitch || 0}
                        </span>

                        <span className="tag">
                          <strong>Colors:</strong> {item.color || "Multi"}
                        </span>
                      </div>
                    </td>

                    {/* <td>{item.area}</td>

                    <td>{item.stitch}</td>

                    <td>{item.color}</td> */}

                    <td>₹ {item.price}</td>
                    {isDesigner && (
                      <>
                        <td
                          className="text-danger fw-bold"
                          style={{ width: "20px" }}
                        >
                          ₹ {item.commission_amount || 0}
                        </td>

                        <td className="text-success fw-bold">
                          ₹ {item.designer_amount || 0}
                        </td>
                      </>
                    )}

                    <td className="download-col">
                      {order.status?.toLowerCase() === "confirmed" ? (
                        downloaded[i] ? (
                          <div className="d-flex justify-content-center align-items-center">
                            <i
                              className="bi bi-check-circle-fill text-success"
                              style={{ fontSize: "26px" }}
                            ></i>
                          </div>
                        ) : (
                          <button
                            onClick={(e) => {
                              e.preventDefault();

                              const link = document.createElement("a");
                              link.href = `${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.emb_file}`;

                              let ext = "emb";

                              if (
                                item.emb_file?.toLowerCase().endsWith(".txt")
                              ) {
                                ext = "emb";
                              } else if (
                                item.emb_file?.toLowerCase().endsWith(".zip")
                              ) {
                                ext = "zip";
                              } else if (
                                item.emb_file?.toLowerCase().endsWith(".rar")
                              ) {
                                ext = "rar";
                              }

                              link.download = `${item.design_code}.${ext}`;

                              document.body.appendChild(link);
                              link.click();
                              link.remove();

                              setDownloaded((prev) => ({
                                ...prev,
                                [i]: true,
                              }));
                            }}
                            className="btn btn-teal btn-sm"
                          >
                            <i className="bi bi-download"></i>
                          </button>
                        )
                      ) : order.status?.toLowerCase() === "pending" ? (
                        <span className="text-muted">Pending Approval</span>
                      ) : order.status?.toLowerCase() === "cancelled" ? (
                        <span className="text-danger">Rejected</span>
                      ) : (
                        <span className="text-muted">Not Available</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <HorizontalAds />
      {showAdModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-dialog">
            <div className="custom-modal-content">
              <div className="modal-header-custom">
                <h2 className="modal-title">Unlocking Your Design</h2>
                <p>We provide 100% free designs thanks to our sponsors.</p>
              </div>

              <div className="ad-card">
                <div className="ad-badge">SPONSORED AD</div>
                <div className="ad-body">
                  {/* <h4 className="ad-brand">Premium Embroidery Supplies</h4>
            <p className="ad-offer">Upgrade your toolkit with 20% off all thread kits.</p> */}
                  <h4 className="ad-brand">Your Ads Here</h4>

                  <div className="ad-visual-placeholder">
                    {/* You can place an actual <img> here */}
                    <div className="pulse-loader"></div>
                  </div>
                </div>
              </div>

              <div className="action-section">
                {adTimer > 0 ? (
                  <div className="timer-wrapper">
                    <span className="timer-text">Preparing your file...</span>
                    <div className="timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="download-ready-area">
                    <p className="ready-msg"> Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url}
                      className="btn-download-glow"
                      onClick={(e) => {
                        e.preventDefault();

                        const link = document.createElement("a");
                        link.href = pendingDownloadUrl.url;

                        let ext = "emb";

                        if (
                          pendingDownloadUrl.url.toLowerCase().endsWith(".txt")
                        ) {
                          ext = "emb";
                        } else if (
                          pendingDownloadUrl.url.toLowerCase().endsWith(".zip")
                        ) {
                          ext = "zip";
                        } else if (
                          pendingDownloadUrl.url.toLowerCase().endsWith(".rar")
                        ) {
                          ext = "rar";
                        }

                        link.download = `${pendingDownloadUrl.code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        link.remove();

                        setDownloaded((prev) => ({
                          ...prev,
                          [pendingDownloadUrl.index]: true,
                        }));

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              <button
                className="btn-close-modal"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
      {previewImage && (
        <div className="preview-modal" onClick={() => setPreviewImage("")}>
          <div
            className="preview-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-close"
              onClick={() => setPreviewImage("")}
            >
              &times;
            </button>

            <img src={previewImage} alt="Preview" />
          </div>
        </div>
      )}
      <style>{`
        .btn-teal { background-color: #1c8079; color: white; border: none; padding: 10px; }
        .design-img-box { overflow: hidden; position: relative; background: #f8f9fa; }
        
        /* BILLARY MIRROR (Zoom Lens) CSS */
    

        .object-fit-contain { object-fit: contain; }



/* Modal Box */
.custom-modal-content {
  background: #ffffff;
  width: 90%;
  max-width: 450px;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-left:16px;
}

.modal-title {
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

/* Ad Container Styling */
.ad-card {
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  margin: 25px 0;
  position: relative;
}

.ad-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #10334b;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

.ad-brand {
  color: #132e4d;
  font-weight: 700;
  margin-top: 10px;
}

/* Timer Styling */
.timer-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ef4444;
  margin-top: 10px;
}

/* Pulsing Loader Animation */
.pulse-loader {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #2e4563;
  border-radius: 50%;
  margin: 15px auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Glow Download Button */
.btn-download-glow {
  display: inline-block;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.4);
  transition: transform 0.2s ease;
}

.btn-download-glow:hover {
  transform: translateY(-2px);
  color: white;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #94a3b8;
  margin-top: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}


.preview-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  padding: 20px;
}

.preview-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-modal-content img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.4);
}

.preview-close {
  position: absolute;
  top: 10px;
  right: 10px;

  width: 40px;
  height: 40px;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  background: #fff;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;

  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
}

.preview-close:hover {
  background: #dc3545;
  color: #fff;
}
      `}</style>
    </div>
  );
}
